import { Directive, Input, Output, EventEmitter, OnInit } from '@angular/core';

@Directive({
	selector: '[postcode]',
	host: {
		'[value]': 'postcode',
		'(input)': 'format($event.target.value)'
	}
})
export class PatentFormatDirective implements OnInit {

	@Input() postcode: string;
	@Output() postcodeChange: EventEmitter<string> = new EventEmitter<string>();

	constructor() {
	}

	ngOnInit() {
		this.postcode = this.postcode || '';
		this.format(this.postcode);
	}

	format(value) {
		if (value) {
			value = value.toUpperCase();
			value = this.quitarFormato(value);
			value = value.substring(0, 6);

			if (value.length === 5) { // Valida patente de moto
				if (this.isMotoOld(value)) {
					value = [value.slice(0, 2), '-', value.slice(2)].join('');
				} else if (this.isMotoNew(value)) {
					value = [value.slice(0, 3), '-', value.slice(3)].join('');
				}
			} else if (value.length === 6) { // Valida patente vehiculo
				if (this.esAntigua(value)) {
					value = [value.slice(0, 2), '-', value.slice(2)].join('');
				} else if (this.esNueva(value)) {
					value = [value.slice(0, 4), '-', value.slice(4)].join('');
				}
			}
			this.postcodeChange.next(value);
		}
	}

	/* Quita caracteres especiales y convierte a mayusculas */
	quitarFormato(patente) {
		return patente.replace(/\W+/g, '').toUpperCase();
	}

	esAntigua(texto) {
		return texto.match(/^[a-z]{2}[\.\- ]?[0-9]{2}[\.\- ]?[0-9]{2}$/i);
	}

	esNueva(texto) {
		return texto.match(/^[b-d,f-h,j-l,p,r-t,v-z]{2}[\-\. ]?[b-d,f-h,j-l,p,r-t,v-z]{2}[\.\- ]?[0-9]{2}$/i);
	}

	isMotoOld(texto) {
		// Validate format XX0111 / XX111 / XXX011 / XXX11
		return texto.match(/^[a-z]{2}0[0-9]{3}$|^[a-z]{2}[0-9]{3}$/i);
	}

	isMotoNew(texto) {
		// Validate format XX0111 / XX111 / XXX011 / XXX11
		return texto.match(/^[b-d,f-h,j-l,p,r-t,v-z]{3}[0-9]{2}$|^[b-d,f-h,j-l,p,r-t,v-z]{3}0[0-9]{2}$/i);
	}

	isCarroArrastre(texto) {
		// Validate format XX0111 / XX111 / XXX011 / XXX11
		return texto.match(/^[a-zA-Z]{3}[1-9]{1}[0-9]{2}$/i);
	}
}
